import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoiceCoreService } from './voice-core.service';
import { VoiceSelectorComponent } from './voice-selector/voice-selector.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [VoiceSelectorComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  providers: [VoiceCoreService],
  exports: [VoiceSelectorComponent],
})
export class VoiceCoreModule {}
